import { Control, Controller, useController } from 'react-hook-form'
import React from 'react'

import { FormData } from '../../ChallengeAdmin'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import ChallengeActivitySelect from '../ChallengeActivitySelect/ChallengeActivitySelect'

interface ChallengePointsIconProps {
  control: Control<FormData, any>
  name: any
  fields: any[]
  index: number
  defaultIcon?: CustomTypeCategory
}

export default function ChallengePointsIconField(props: ChallengePointsIconProps) {
  const { control, name, defaultIcon } = props
  const {
    field: { onChange, name: controllerName, value, ref },
  } = useController({
    control,
    name,
  })

  return (
    <>
      <Controller
        name={controllerName}
        control={control}
        render={({ field: { ref, ...otherField } }) => (
          <ChallengeActivitySelect isIconSelect={true} selectedActivity={value} onSelect={onChange} />
        )}
      />
    </>
  )
}
